<template>
  <section>
    <el-table
      :data="tableData"
      class="el-table-info"
      stripe
      style="margin-left: 5%;width: 90%;"
    >
      <el-table-column
        :formatter="publicFmt"
        prop="costData"
        label="撤销费用"
        >
      </el-table-column>
    </el-table>
    <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;">
      <!-- <div class="sp_add_left" style="display:flex;">
        <div style="width: 40%;line-height: 40px;">进票总金额:</div>
        <div style="width: 60%">
          <el-input v-model="applicationForm.totalPayment"  clearable disabled>
            <template slot="append">元</template>
          </el-input>
        </div>
      </div> -->
      <div class="sp_add_right" style="display:flex;">
        <div style="width: 30%;line-height: 40px;">开票公司:</div>
        <div style="width: 70%;line-height: 40px;text-align: left;">
          {{applicationForm.sellerName}}
        </div>
      </div>
    </div>
    <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;">
      <div class="sp_add_left" style="display:flex;">
        <div style="width: 30%;line-height: 40px;">发票金额:</div>
        <div style="width: 70%">
          <el-input v-model="applicationForm.invoicePrice" placeholder="发票金额"  clearable disabled>
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>
      <div class="sp_add_right" style="display:flex;">
        <div style="width: 30%;line-height: 40px;">发票号:</div>
        <div style="width: 70%">
          <el-input v-model="applicationForm.invoiceNo" placeholder="无票号" clearable disabled>
          </el-input>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { getInvoiceRefundRecordByProcessId } from '@/api/invoiceOcrRecord'
import {ERR_OK} from "@/jslib/config";
export default {
  name: "InvoiceRefundApprove",
  props: {
    datas: {
      type: Object
    },
    applyObj: {
      type: Object
    },
  },
  data() {
    return {
      tableData: [],
      dictionaryLists: [],
      applicationForm: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(params1) {
      this.tableData = []
      this.applicationForm = {}
      console.info(this.applyObj,this.datas)
      if(this.applyObj){
        this.tableData = this.applyObj.matcher && this.applyObj.matcher.length > 0 ? this.applyObj.matcher.slice(0,1) : []
        this.applicationForm = this.applyObj
      } else {
        if (!params1 && (!this.datas || !this.datas.processId)) {
          return
        }
        const invoiceFund = params1 || this.datas.params3 && JSON.parse(this.datas.params3)
        // console.log('p3', invoiceFund)
        // console.log(invoiceFund.invoiceNo)
        if(invoiceFund){
          this.tableData = invoiceFund.matcher
          this.applicationForm = invoiceFund
        }
        // getInvoiceRefundRecordByProcessId(invoiceFund).then(res =>{
        //   if (res!=undefined&&res.resultCode === ERR_OK) {
        //     this.applicationForm = res.obj
        //     this.tableData = res.list
        //     this.applicationForm.totalPayment = Number(this.applicationForm.ticketPayment)+Number(this.applicationForm.additionalPrice)
        //   }
        // })
      }
    },
    publicFmt(row,column,cellValue,index){
            var v = '--'
            if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
              v = cellValue
            }
            return v
          },
  }
}
</script>
  <style scoped>
  .query-form{
    text-align: left;
    padding-top: 10px;
  }
  .sp_add_left{
    width: 45%;
    margin-right: 5%;
  }
  .sp_add_right{
    width: 45%;
  }
  .el-table-info >>> .cell{
    text-align: center;
    white-space: pre-line;
  }
  .el-table-info >>> th {
    background: #EDF5FF;
  }
  </style>
